"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var types = _interopRequireWildcard(require("./types"));
var _apis = require("./apis");
var _actions = require("../notification/actions");
var _actions2 = require("./actions");
var _selectors = require("./selectors");
var _middlewares = require("../network/middlewares");
var _api = require("../../utils/api");
var _schemas = require("./schemas");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _logger.default('saga:voiceMails');
function getVoiceMails(_ref) {
  var {
    query,
    page
  } = _ref;
  return function* () {
    logger.log('getVoiceMails', {
      query,
      page
    });
    _callbacks.default.get('analyticsLogEvent')('getVoiceMails', {
      query,
      page
    });
    var isSupported = yield (0, _effects.select)(_selectors.voiceMailSupportedSelector);
    if (!isSupported) {
      logger.log('VoiceMails note supported by this account');
      yield (0, _effects.put)((0, _actions2.setVoiceMailsError)(new Error('VoiceMails note supported by this account')));
      return false;
    }
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$getVoiceMails, query, page);
      var _voiceMails = yield* (0, _api.normalizeApiResponse)(data, [_schemas.voiceMails]);
      if (_voiceMails) {
        yield (0, _effects.put)((0, _actions2.setVoiceMails)(_voiceMails));
      }
    } catch (e) {
      var _e$response;
      if ((0, _middlewares.isNetworkError)(e)) {
        yield (0, _effects.put)((0, _actions2.setVoiceMailsError)(e));
      } else if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 404) {
        yield (0, _effects.put)((0, _actions2.setVoiceMails)([]));
      } else {
        yield (0, _effects.put)((0, _actions2.setVoiceMailsError)(e));
        yield (0, _effects.put)((0, _actions.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'VM1',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getVoiceMails');
      }
    }
  }();
}
function getVoiceMail(_ref2) {
  var {
    _voiceMail
  } = _ref2;
  return function* () {
    logger.log('getVoiceMail', {
      _voiceMail
    });
    _callbacks.default.get('analyticsLogEvent')('getVoiceMail', _voiceMail);
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$getVoiceMail, _voiceMail);
      var _voiceMails = yield* (0, _api.normalizeApiResponse)(data, _schemas.voiceMails);
      if (_voiceMails) {
        yield (0, _effects.put)((0, _actions2.setVoiceMails)(_voiceMails));
      }
    } catch (e) {
      if ((0, _middlewares.isNetworkError)(e)) return;
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'VM2',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'getVoiceMail');
    }
  }();
}
function patchVoiceMail(_ref3) {
  var {
    _voiceMail,
    voiceMail
  } = _ref3;
  return function* () {
    logger.log('patchVoiceMail', {
      _voiceMail,
      voiceMail
    });
    _callbacks.default.get('analyticsLogEvent')('patchVoiceMail', {
      _voiceMail,
      voiceMail
    });
    try {
      yield (0, _effects.call)(_apis.$patchVoiceMail, _voiceMail, voiceMail);
      var defaultValues = yield (0, _effects.select)(state => (0, _selectors.getVoiceMailByIdSelector)(state, _voiceMail));
      yield* (0, _api.normalizeApiResponse)(_objectSpread(_objectSpread({}, defaultValues), voiceMail), _schemas.voiceMails);
    } catch (e) {
      if ((0, _middlewares.isNetworkError)(e)) return;
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'VM3',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'patchVoiceMail');
    }
  }();
}
function deleteVoiceMailLogic(_ref4) {
  var {
    _voiceMail
  } = _ref4;
  return function* () {
    logger.log('deleteVoiceMail', {
      _voiceMail
    });
    _callbacks.default.get('analyticsLogEvent')('deleteVoiceMail', {
      _voiceMail
    });
    try {
      yield (0, _effects.call)(_apis.$deleteVoiceMail, _voiceMail);
      yield (0, _effects.put)((0, _actions2.deleteVoiceMails)([_voiceMail]));
    } catch (e) {
      if ((0, _middlewares.isNetworkError)(e)) return;
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'VM4',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'deleteVoiceMail');
    }
  }();
}
function deleteVoiceMailsLogic(_ref5) {
  var {
    _voiceMails
  } = _ref5;
  return function* () {
    logger.log('deleteVoiceMailsLogic', {
      _voiceMails
    });
    _callbacks.default.get('analyticsLogEvent')('deleteVoiceMailsLogic', {
      _voiceMails
    });
    try {
      yield (0, _effects.call)(_apis.$deleteVoiceMails, _voiceMails);
      yield (0, _effects.put)((0, _actions2.deleteVoiceMails)(_voiceMails));
    } catch (e) {
      if ((0, _middlewares.isNetworkError)(e)) return;
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'VM5',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e, 'deleteVoiceMailsLogic');
    }
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)(types.REQUEST_GET_VOICE_MAILS, getVoiceMails), (0, _sagas.takeLatest)(types.REQUEST_GET_VOICE_MAIL, getVoiceMail), (0, _sagas.takeLatest)(types.REQUEST_PATCH_VOICE_MAIL, patchVoiceMail), (0, _sagas.takeLatest)(types.REQUEST_DELETE_VOICE_MAIL, deleteVoiceMailLogic), (0, _sagas.takeLatest)(types.REQUEST_DELETE_VOICE_MAILS, deleteVoiceMailsLogic)]);
}
module.exports = exports.default;